import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Form, Container, Row, Col } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import OtpInput from "react-otp-input";
import { zodResolver } from "@hookform/resolvers/zod";

// css
import styles from "../../../layout/Auth/Auth.module.scss";

// img
import user from "../../../Assets/images/user.png";
import { z } from "zod";
import { useForm } from "react-hook-form";
import fileUploader from "../../../utilities/fileUploader";
import { useDispatch } from "react-redux";
import { signUp } from "../../../store/actions";
import { GET_EMAIL_OTP } from "../../../services/ApiCalls";
// import { getValue } from "@testing-library/user-event/dist/utils";
import { toast } from "react-toastify";
import validator from "validator";
import EditIcon from "../../../Assets/icons/EditIcon";
import DeleteIcon from "../../../Assets/icons/DeleteIcon";

const schema = z
  .object({
    businessName: z
      .string()
      .trim()
      .min(1, { message: "Business name is required" }),
    firstName: z.string().trim().min(1, { message: "First name is required" }),
    lastName: z.string().trim().min(1, { message: "Last name is required" }),
    einNumber: z.string().trim().min(1, { message: "EIN Number is required" }),
    businessAddress: z
      .string()
      .trim()
      .min(1, { message: "Last name is required" }),
    email: z
      .string({
        required_error: "email is required",
      })
      .min(1, { message: "Email is required" })
      .email("Invalid email address"),
    password: z.string().min(1, { message: "Password is required" }),
    cnfPassword: z.string().min(1, { message: "Password is required" }),
    otp: z.string().trim().min(4, { message: "Otp is required" }),
  })
  .refine((data) => data.password === data.cnfPassword, {
    path: ["cnfPassword"],
    message: "Passwords does not match",
  });

const SignUp = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const [contactNumber, setContactNUmber] = useState({
    countryCode: "",
    mobileNumber: "",
  });
  const [Error, setError] = useState({
    contactNumber: "",
  });
  const [showPass, setShowPass] = useState({
    password: false,
    confirmPassword: false,
  });

  const handlePassword = (fieldName) => {
    setShowPass((prevState) => ({
      ...prevState,
      [fieldName]: !prevState[fieldName],
    }));
  };
  const [proofImages, setProofImages] = useState([]);
  const [profileImage, setProfileImage] = useState();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    getValues,
    setError: setFormError,
  } = useForm({
    resolver: zodResolver(schema),
  });

  const getOtpHandler = async () => {
    const email = getValues("email");

    if (!validator.isEmail(email)) {
      return setFormError("email", {
        type: "manual",
        message: "Invalid email address",
      });
    }
    try {
      const res = await GET_EMAIL_OTP({ email });

      if (res?.data?.status === "success") {
        toast.success(res?.data?.message);
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  const submitHandler = (data) => {
    if (
      !contactNumber.countryCode.trim() ||
      !contactNumber.mobileNumber.trim()
    ) {
      return setError((p) => ({
        ...p,
        contactNumber: "Phone Number is Required",
      }));
    } else {
      setError((p) => ({ ...p, contactNumber: "" }));
    }

    const callBack = () => {
      navigate("/login");
    };

    dispatch(
      signUp(
        {
          ...data,
          type: "agency",
          ...(proofImages && {
            documentsList: proofImages.map((item) => ({
              image: item,
              number: data.einNumber,
            })),
          }),
          ...contactNumber,
          ...(profileImage && {
            profileImage: profileImage,
          }),
        },
        callBack
      )
    );
  };

  const removeProofHandler = (ind) => {
    const newArr = [...proofImages];

    newArr.splice(ind, 1);

    setProofImages((p) => newArr);
  };

  const imageUploadHandler = async (e, type) => {
    const url = await fileUploader(e.target.files[0]);

    if (!url) {
      return;
    }

    if (type === "proof") {
      setProofImages((p) => [url]);
    }

    if (type === "profile") {
      setProfileImage(url);
    }
  };

  return (
    <>
      <div className="formInner px-lg-5 position-relative d-flex align-items-center justify-content-center flex-column h-100">
        <div className="w-100 inner">
          <div className="top py-2 d-flex align-items-center gap-10">
            <div className="imgWrp position-relative me-lg-4">
              <label htmlFor="file">
                <span
                  className="icn position-absolute"
                  style={{ bottom: 0, right: 0, cursor: "pointer" }}
                >
                  <input
                    type="file"
                    className="d-none"
                    id="file"
                    onChange={(e) => imageUploadHandler(e, "profile")}
                  />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 31 31"
                    fill="none"
                  >
                    <circle cx="15.5" cy="15.5" r="15.5" fill="#C11111" />
                    <path
                      d="M12 21.55V18.7167L21.75 9L24.5333 11.85L14.8333 21.55H12ZM21.7333 12.75L22.6667 11.8167L21.7333 10.8833L20.8 11.8167L21.7333 12.75Z"
                      fill="white"
                    />
                  </svg>
                </span>
              </label>
              <img
                src={profileImage || user}
                alt=""
                className="img-fluid rounded-circle"
                style={{
                  aspectRatio: 1,
                  height: 80,
                  width: 80,
                  cursor: "pointer",
                }}
              />
            </div>
            <h4 className="m-0 fw-sbold">Create Account</h4>
          </div>
          <Form
            className={`${styles.form}`}
            onSubmit={handleSubmit(submitHandler)}
          >
            <Row>
              <Col md="6" className="my-2">
                <input
                  type="text"
                  className={`${styles.formControl} form-control bg-white`}
                  placeholder="Business Name"
                  {...register("businessName")}
                />
                {
                  <p className="errorColor">
                    {errors?.businessName && errors.businessName?.message}
                  </p>
                }
              </Col>
              <Col md="6" className="my-2">
                <input
                  type="text"
                  className={`${styles.formControl} form-control bg-white`}
                  placeholder="Business address"
                  {...register("businessAddress")}
                />
                {
                  <p className="errorColor">
                    {errors?.businessAddress &&
                      errors?.businessAddress?.message}
                  </p>
                }
              </Col>
              <Col md="6" className="my-2">
                <input
                  type="text"
                  className={`${styles.formControl} form-control bg-white`}
                  placeholder="First Name"
                  {...register("firstName")}
                />
                {
                  <p className="errorColor">
                    {errors?.firstName && errors.firstName?.message}
                  </p>
                }
              </Col>
              <Col md="6" className="my-2">
                <input
                  type="text"
                  className={`${styles.formControl} form-control bg-white`}
                  placeholder="Last Name"
                  {...register("lastName")}
                />
                {
                  <p className="errorColor">
                    {errors?.lastName && errors.lastName?.message}
                  </p>
                }
              </Col>
              <Col md="6" className="my-2">
                <PhoneInput
                  value={`${contactNumber.countryCode}Code, "+" + ${contactNumber.mobileNumber}`}
                  onChange={(mobileNumber, { dialCode }) => {
                    setContactNUmber((p) => ({
                      countryCode: `+${dialCode}`,
                      mobileNumber: mobileNumber.replace(dialCode, ""),
                    }));
                  }}
                  country={'us'}
                />
                {
                  <p className="errorColor">
                    {Error?.contactNumber && Error.contactNumber}
                  </p>
                }
              </Col>
              <Col md="6" className="my-2">
                <div className="iconWithText position-relative">
                  <input
                    type="text"
                    className={`${styles.formControl} form-control bg-white`}
                    placeholder="Email"
                    {...register("email")}
                  />

                  <Button
                    className="icn py-1 position-absolute commonBtn h-auto px-2"
                    style={{ right: 5, minWidth: "unset", fontSize: 10 }}
                    type="button"
                    onClick={getOtpHandler}
                  >
                    Get Otp
                  </Button>
                </div>
                {
                  <p className="errorColor">
                    {errors?.email && errors.email?.message}
                  </p>
                }
              </Col>
              <Col md="12" className="my-2">
                <label htmlFor="" className="form-label fw-sbold text-muted">
                  Enter OTP{" "}
                </label>
                <div className="otp">
                  <OtpInput
                    value={watch("otp")}
                    onChange={(e) => {
                      setValue("otp", e);
                    }}
                    numInputs={4}
                    renderInput={(props) => <input {...props} />}
                  />
                </div>
                {
                  <p className="errorColor">
                    {errors?.otp && errors?.otp?.message}
                  </p>
                }
              </Col>
              <Col md="6" className="my-2">
                <div className="position-relative iconWithText">
                  <input
                    type={showPass.password ? "text" : "password"}
                    className={`${styles.formControl} form-control bg-white`}
                    placeholder="Password"
                    {...register("password")}
                  />
                  <Button
                    variant="transparent"
                    onClick={() => handlePassword("password")}
                    className="border-0 p-0 position-absolute icn"
                    style={{ right: 10 }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 25 17"
                      fill="none"
                    >
                      <path
                        d="M24.8389 7.9541C22.8564 5.34668 20.8301 3.35937 18.8184 2.04102C16.7578 0.693359 14.6582 0.00488281 12.5684 0C12.5586 0 12.5488 0 12.5391 0C10.4443 0 8.3252 0.683594 6.25 2.03613C4.22363 3.34961 2.17285 5.3418 0.161133 7.94922C-0.0537109 8.23242 -0.0537109 8.62305 0.161133 8.90137C2.17285 11.5137 4.22363 13.5059 6.25 14.8193C8.33008 16.1719 10.4443 16.8555 12.5391 16.8555H12.5684C14.6582 16.8506 16.7627 16.1621 18.8184 14.8145C20.8301 13.4961 22.8516 11.5088 24.8389 8.90137C25.0537 8.62305 25.0537 8.23242 24.8389 7.9541ZM12.5635 15.293C12.5537 15.293 12.5439 15.293 12.5391 15.293C9.02832 15.293 5.40527 12.9834 1.77246 8.42773C5.40527 3.87207 9.02344 1.5625 12.5391 1.5625H12.5635C16.0645 1.57227 19.6533 3.88184 23.2275 8.42773C19.6533 12.9736 16.0693 15.2832 12.5635 15.293ZM12.5 3.54492C9.80957 3.54492 7.61719 5.73731 7.61719 8.42773C7.61719 11.1182 9.80957 13.3105 12.5 13.3105C15.1904 13.3105 17.3828 11.1182 17.3828 8.42773C17.3828 5.73731 15.1904 3.54492 12.5 3.54492ZM12.5 11.748C10.6689 11.748 9.17969 10.2588 9.17969 8.42773C9.17969 6.59668 10.6689 5.10742 12.5 5.10742C14.3311 5.10742 15.8203 6.59668 15.8203 8.42773C15.8203 10.2588 14.3311 11.748 12.5 11.748Z"
                        fill="#666666"
                      ></path>
                    </svg>
                  </Button>
                </div>

                {
                  <p className="errorColor">
                    {errors?.password && errors?.password?.message}
                  </p>
                }
              </Col>{" "}
              <Col md="6" className="my-2">
                <div className="position-relative iconWithText">
                  <input
                    type={showPass.confirmPassword ? "text" : "password"}
                    className={`${styles.formControl} form-control bg-white`}
                    placeholder="Confirm Password"
                    {...register("cnfPassword")}
                  />
                  <Button
                    variant="transparent"
                    onClick={() => handlePassword("confirmPassword")}
                    className="border-0 p-0 position-absolute icn"
                    style={{ right: 10 }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 25 17"
                      fill="none"
                    >
                      <path
                        d="M24.8389 7.9541C22.8564 5.34668 20.8301 3.35937 18.8184 2.04102C16.7578 0.693359 14.6582 0.00488281 12.5684 0C12.5586 0 12.5488 0 12.5391 0C10.4443 0 8.3252 0.683594 6.25 2.03613C4.22363 3.34961 2.17285 5.3418 0.161133 7.94922C-0.0537109 8.23242 -0.0537109 8.62305 0.161133 8.90137C2.17285 11.5137 4.22363 13.5059 6.25 14.8193C8.33008 16.1719 10.4443 16.8555 12.5391 16.8555H12.5684C14.6582 16.8506 16.7627 16.1621 18.8184 14.8145C20.8301 13.4961 22.8516 11.5088 24.8389 8.90137C25.0537 8.62305 25.0537 8.23242 24.8389 7.9541ZM12.5635 15.293C12.5537 15.293 12.5439 15.293 12.5391 15.293C9.02832 15.293 5.40527 12.9834 1.77246 8.42773C5.40527 3.87207 9.02344 1.5625 12.5391 1.5625H12.5635C16.0645 1.57227 19.6533 3.88184 23.2275 8.42773C19.6533 12.9736 16.0693 15.2832 12.5635 15.293ZM12.5 3.54492C9.80957 3.54492 7.61719 5.73731 7.61719 8.42773C7.61719 11.1182 9.80957 13.3105 12.5 13.3105C15.1904 13.3105 17.3828 11.1182 17.3828 8.42773C17.3828 5.73731 15.1904 3.54492 12.5 3.54492ZM12.5 11.748C10.6689 11.748 9.17969 10.2588 9.17969 8.42773C9.17969 6.59668 10.6689 5.10742 12.5 5.10742C14.3311 5.10742 15.8203 6.59668 15.8203 8.42773C15.8203 10.2588 14.3311 11.748 12.5 11.748Z"
                        fill="#666666"
                      ></path>
                    </svg>
                  </Button>
                </div>

                {
                  <p className="errorColor">
                    {errors?.cnfPassword && errors.cnfPassword?.message}
                  </p>
                }
              </Col>
              <Col md="6" className="my-2">
                <div
                  className="upload position-relative text-center p-3 bg-white rounded"
                  style={{ border: "1px solid rgb(221, 221, 221)" }}
                >
                  <input
                    type="file"
                    style={{ zIndex: 9, left: 0, top: 0 }}
                    className="file cursor-pointer position-absolute h-100 w-100"
                    onChange={(e) => imageUploadHandler(e, "proof")}
                  />
                  {proofImages.length > 0 ? (
                    <>
                      {proofImages?.map((item, ind) => {
                        return (
                          <div className="position-relative p-2 d-inline-block">
                            <div
                              className="position-absolute flex-column d-flex"
                              style={{ left: 0, top: 0 }}
                            >
                              <Button
                                className="commonBtn justify-content-center align-items-center rounded-circle border-0 p-0 d-inline-flex  fw-sbold rounded-circle my-1"
                                style={{
                                  minWidth: "unset",
                                  zIndex: 9999,
                                  height: 20,
                                  width: 20,
                                }}
                                onClick={() => removeProofHandler(ind)}
                              >
                                <DeleteIcon />
                              </Button>
                              <Button
                                className="commonBtn position-relative justify-content-center align-items-center rounded-circle border-0 p-0 d-inline-flex  fw-sbold rounded-circle my-1"
                                style={{
                                  minWidth: "unset",
                                  zIndex: 9999,
                                  height: 20,
                                  width: 20,
                                }}
                              >
                                <input
                                  type="file"
                                  onChange={(e) =>
                                    imageUploadHandler(e, "proof")
                                  }
                                  className="file  position-absolute w-100 h-100"
                                />
                                <EditIcon />
                              </Button>
                            </div>
                            <img
                              className="img-fluid w-100 h-100 object-fit-contain"
                              src={item}
                              key={ind}
                              style={{ height: 160 }}
                            />
                          </div>
                        );
                      })}
                    </>
                  ) : (
                    <>
                      <span className="icn d-block mb-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="17"
                          viewBox="0 0 18 17"
                          fill="none"
                        >
                          <path
                            d="M5.80049 13.6739H4.4474C2.37551 13.5259 1.44531 11.9332 1.44531 10.5167C1.44531 9.10022 2.37552 7.5005 4.41217 7.35956C4.7011 7.33137 4.9548 7.55688 4.97594 7.85286C4.99708 8.1418 4.77865 8.3955 4.48267 8.41664C3.1155 8.5153 2.5024 9.54419 2.5024 10.5238C2.5024 11.5033 3.1155 12.5322 4.48267 12.6309H5.80049C6.08943 12.6309 6.32904 12.8705 6.32904 13.1594C6.32904 13.4484 6.08943 13.6739 5.80049 13.6739Z"
                            fill="#292D32"
                          />
                          <path
                            d="M12.2908 13.6737C12.2767 13.6737 12.2696 13.6737 12.2555 13.6737C11.9666 13.6737 11.6988 13.4341 11.6988 13.1451C11.6988 12.8421 11.9243 12.6166 12.2203 12.6166C13.0871 12.6166 13.8623 12.3136 14.4684 11.7709C15.5677 10.8125 15.6382 9.43124 15.3422 8.45872C15.0462 7.49325 14.2217 6.38683 12.7841 6.21065C12.5515 6.18246 12.3683 6.00629 12.326 5.77373C12.0441 4.08239 11.135 2.91255 9.75378 2.48972C8.33024 2.04574 6.66707 2.48267 5.63112 3.56794C4.62337 4.61798 4.39082 6.09085 4.97574 7.71171C5.0744 7.98656 4.93349 8.28958 4.65865 8.38824C4.3838 8.4869 4.08076 8.34596 3.9821 8.07112C3.27033 6.0838 3.59451 4.18105 4.87005 2.84208C6.17379 1.47491 8.26681 0.932272 10.0639 1.48196C11.7129 1.98936 12.8757 3.34947 13.2985 5.23813C14.7361 5.5623 15.8919 6.65463 16.35 8.16274C16.8503 9.80474 16.3993 11.4961 15.166 12.5673C14.3838 13.272 13.3619 13.6737 12.2908 13.6737Z"
                            fill="#292D32"
                          />
                          <path
                            d="M8.99942 15.7457C7.58293 15.7457 6.25806 14.9916 5.5322 13.7724C5.45468 13.6526 5.37716 13.5117 5.31374 13.3567C5.07413 12.8563 4.94727 12.2855 4.94727 11.6935C4.94727 9.45954 6.76545 7.64136 8.99942 7.64136C11.2334 7.64136 13.0516 9.45954 13.0516 11.6935C13.0516 12.2925 12.9247 12.8563 12.671 13.3778C12.6147 13.5117 12.5371 13.6526 12.4526 13.7865C11.7408 14.9916 10.4159 15.7457 8.99942 15.7457ZM8.99942 8.69844C7.35037 8.69844 6.00435 10.0445 6.00435 11.6935C6.00435 12.1304 6.09597 12.5392 6.27215 12.9127C6.32853 13.0325 6.37784 13.1311 6.43422 13.2228C6.96981 14.1319 7.94938 14.6886 8.99237 14.6886C10.0354 14.6886 11.0149 14.1319 11.5435 13.2369C11.6069 13.1312 11.6633 13.0325 11.7056 12.9338C11.8959 12.5462 11.9874 12.1375 11.9874 11.7006C11.9945 10.0445 10.6485 8.69844 8.99942 8.69844Z"
                            fill="#292D32"
                          />
                          <path
                            d="M8.59801 12.9196C8.46411 12.9196 8.33023 12.8703 8.22452 12.7646L7.52681 12.0669C7.32244 11.8625 7.32244 11.5243 7.52681 11.3199C7.73118 11.1155 8.06945 11.1155 8.27382 11.3199L8.61211 11.6582L9.73965 10.6152C9.95812 10.4179 10.2893 10.4319 10.4867 10.6434C10.684 10.8548 10.6699 11.1931 10.4585 11.3904L8.95742 12.7787C8.85171 12.8703 8.72486 12.9196 8.59801 12.9196Z"
                            fill="#292D32"
                          />
                        </svg>
                      </span>

                      <p
                        className="m-0 text-dark"
                        style={{ fontSize: 11, lineHeight: "16px" }}
                      >
                        Choose a file or drag & drop it here
                      </p>
                      <p
                        className="m-0 text-muted fw-sbold"
                        style={{ fontSize: 11, lineHeight: "16px" }}
                      >
                        Certificate of incorporation{" "}
                      </p>
                      <div className="btnWrpper mt-3">
                        <Button
                          className="d-inline-flex align-items-center justify-content-center py-1 px-2 border h-auto"
                          style={{ fontSize: 12 }}
                          variant="transparent"
                        >
                          Browse File
                        </Button>
                      </div>
                    </>
                  )}
                </div>
              </Col>
              <Col md="6" className="my-2 align-self-center">
                <input
                  type="text"
                  className={`${styles.formControl} form-control bg-white`}
                  placeholder="EIN number"
                  {...register("einNumber")}
                />
                {
                  <p className="errorColor">
                    {errors?.einNumber && errors.einNumber?.message}
                  </p>
                }
              </Col>
              <Col md="12" className="my-2">
                <div className="btnWrpper">
                  <Button
                    type="submit"
                    className="d-flex align-items-center justify-content-center w-100 commonBtn"
                  >
                    Submit
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
          <div className="py-2">
            <p className={` m-0 fw-sbold text-center`}>
              Already have account{" "}
              <Link to={"/login"} className="themeClr">
                Sign in
              </Link>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
export default SignUp;
